import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const AddressSkeleton = () => <MultipleInputSkeleton count={4} />

export default memo(AddressSkeleton)
